// extracted by mini-css-extract-plugin
export default {"root":"WastageImagesPage_root__NDj32","image-results":"WastageImagesPage_image-results__Xe2Wz","fallback":"WastageImagesPage_fallback__WIIvI"};